import React from 'react'
import Navbar from '../inc/Navbar'

import { Link } from "react-router-dom";

import ScrollToTop from "react-scroll-to-top";




function Coscholastics() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
         <div className="album py-1">
                <div className="container">
                    <h1> KRISHNAGAR PUBLIC SCHOOL </h1>
                </div>
            </div>

            <div className='cbscschoolnadia'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Co-Scholastics <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <ScrollToTop smooth top="100" color="#1D4D93"/>
            <br />
            <div className="album py-0">
                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 className="card-title mb-3"><b>CO-SCHOLASTICS   </b></h1>
                            <div className="col-md-3">
                                <hr style={{color:"#1D4D93"}}/>
                                </div>
                        </div>
                        <div className="album py-0">
                            <div className="container">
                                <div className="row">
                                    
                                    <div className="col-md-12 mt-3">
                                        <h5 className='mb-1 underline' style={{color:"#0f2d5b"}}><b>Sports & Games :-</b></h5>
                                        <p className='justify mb-3'>KPS provides a comprehensive sports and physical education programme with trained coaches and sophisticated well-equipped sporting infrastructure. Being associated with the Khelo India Initiative and the Fit India Movement, the school boasts of an atmosphere that provides exposure to the students to various state and national tournaments and constantly inspire them to enhance their fitness as well.  </p>
                                       
                                        <h5 className='mb-1 underline' style={{color:"#0f2d5b"}}><b>Martial Art & Yoga :-</b></h5>
                                        <p className='justify mb-3'>Our Martial Arts and Yoga programmes not only helps our students become physically active and trained in the much-required skills of self-defense but also helps them become mentally agile and spiritually enlightened. They also develop several important skills like discipline, confidence, conflict avoidance, working well with others, respecting others and oneself and many more through constant engagement in these programs.  </p>


                                        <h5 className='mb-1 underline' style={{color:"#0f2d5b"}}><b>Music & Dance :-</b></h5>
                                        <p className='justify mb-3'>At KPS the students are exposed to an atmosphere of cultural practices and performative arts like dance and music- in both Indian and Western traditions. With specialized trainers for different forms, the students are given exposure to inculcate their interest and engage in a journey of rhythm, harmony and synchronization.</p>

                                        <h5 className='mb-1 underline' style={{color:"#0f2d5b"}}><b>Art & Craft:-</b></h5>
                                        <p className='justify mb-3'>The school building is fully IT enabled and the campus boasts of a 100% CCTV monitoring ensuring the utmost safety of every child. </p>

                                        <h5 className='mb-1 underline' style={{color:"#0f2d5b"}}><b>Debate & Dramatics:-</b></h5>
                                        <p className='justify mb-3'>Our activities are planned not only to inculcate the spirit of a hobby or passion but to prepare our young buds to adapt to the changing world and prepare for the challenges outside the boundaries of the school. Our Debate and Elocution programme not only boost essential critical-thinking and presentation skills, but also develop their social skills and help them emerge as great public speakers. Through Dramatics, the students not only get the scope to bring humour and laughter to their learning but also learn to express a multitude of emotions thereby helping them become more aware of themselves and to be able to release stress. </p>


                                        <h5 className='mb-1 underline' style={{color:"#0f2d5b"}}><b>Club Activities :-</b></h5>
                                        <p className='justify mb-3'>Our Club System is designed in a way to help the students learn skills that are dormant within them. These activities not only help them enhance their precious soft skills but also develop their emotional intelligence. </p>





                                    </div>
                                    
                                       


                                      
                                </div>
                            </div>
                        </div>
                        <br />





                    </div>
                </div>
            </div>



        </div>
    )
}

export default Coscholastics